export const CHART_DOWNLOAD_REQUEST_SUCCESS = "Your request is being processed and you will be alerted when the chart is ready for download";
export const CHART_DOWNLOAD_REQUEST_FAILURE = "Your Chart download request has failed.";
